import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import HeaderZaptrance from './HeaderZaptrance';
import ZaptranceSideNav from './ZaptranceSideNav';
import Modal from 'react-modal';

import axios from 'axios';

import AddInstitutionModal from './modals/AddInstitutionModal';
import BusinessIcon from '@mui/icons-material/Business';
import EditIcon from '@mui/icons-material/ModeOutlined';
import DeleteIcon from '@mui/icons-material/DeleteForeverOutlined';
import FilterIcon from '@mui/icons-material/FilterListOutlined';


import AddProgramToInstitutionModal from './modals/AddProgramToInstitutionModal';
import AddPaymentToInstitutionModal from './modals/AddPaymentToInstitutionModal';
import AddUserToInstitutionModal from './modals/AddUserToInstitutionModal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCalendarAlt, faBuilding } from '@fortawesome/free-solid-svg-icons';

import ComponentUsers from './ComponentUsers';
import ComponentPayments from './ComponentPayments';
import ComponentPrograms from './ComponentPrograms';

import UpdateModal from '../landing/modals/UpdateModal';
import LoadingScreen from '../../LoadingScreen';


const ZaptranceInstitutionDetail = () => {
  const navigate = useNavigate();
  
  // Define state variables to store data
  const [currentInstitution, setCurrentInstitution] = useState('');

  const [cIcurrentInstitutionName, setCIcurrentInstitutionName] = useState('');
  const [cIcurrentInstitutionStatus, setCIcurrentInstitutionStatus] = useState('');
  const [cIcurrentInstitutionEmail, setCIcurrentInstitutionEmail] = useState('');
  const [cIcurrentInstitutionOnBoardingYear, setCIcurrentInstitutionOnBoardingYear] = useState('');


  const [loading, setLoading] = useState(true);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  
  //const [programTypes, setProgramTypes] = useState([]);

  const [registrationErrorMessage, setRegistrationErrorMessage] = useState(null);

  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  const [activeTab, setActiveTab] = useState('users');


  const [errorMessage, setErrorMessage] = useState('');
  const [isRegistrationLoading, setIsRegistrationLoading] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState(null);


  //
  const currentYear = new Date().getFullYear();
  const pastYears = Array.from({ length: 7 }, (_, i) => currentYear - i);
  //const pastYears = Array.from({ length: 5 }, (_, i) => currentYear - i).filter(year => year !== currentYear); // Exclude current year
  
  //const futureYears = Array.from({ length: 5 }, (_, i) => currentYear + i);
  // const years = [...pastYears, ...futureYears];
  const years = [...pastYears];
  //



  //
  const [isAddProgramModalOpen, setIsAddProgramModalOpen] = useState(false);
  const openAddProgramModal = () => {
    if (loading) {
      alert("please wait");
    } else {
      setIsAddProgramModalOpen(true);
    }
     
  };
  const closeAddProgramModal = () => {
    setIsAddProgramModalOpen(false);
  };


  const [isAddPaymentModalOpen, setIsAddPaymentModalOpen] = useState(false);
  const openAddPaymentModal = () => {
    if (loading) {
      alert("please wait");
    } else {
    setIsAddPaymentModalOpen(true);
    }
  };
  const closeAddPaymentModal = () => {
    setIsAddPaymentModalOpen(false);
  };


  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const openAddUserModal = () => {
    if (loading) {
      alert("please wait");
    } else {
    setIsAddUserModalOpen(true);
    }
  };
  const closeAddUserModal = () => {
    setIsAddUserModalOpen(false);
  };
  //

  //let params = useParams();
  const { institution, additionalVariable } = useParams();
  const parsedInstitution = JSON.parse(decodeURIComponent(institution));
  //alert("parsedInstitution: " + parsedInstitution.id);


 
  const clearFields = () => {

  }

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  let token = localStorage.getItem('token');
  useEffect(() => {
    if (!token) {
      // Redirect to the home page if the token is null
      navigate('/');
    } else {
      // If the user is authenticated, call the handleData function
      handleData();
    }
  }, [navigate]);


  
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInstitution, setSelectedInstitution] = useState([]);
  // const [showDialog, setShowDialog] = useState(false);




  const handleData = async () => {
    setLoading(true);
    try {
      // Make the login request to obtain the data
      const response = await axios.get("https://gacsstage.zaptrance.ng/api/admin/institutions/" + parsedInstitution.id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setLoading(false);
      // Check if the request was successful
      if (response.data.success) {
        //alert("institution: " + JSON.stringify(response.data.data, null, 2));

        // Store the retrieved data in state variables
        setCurrentInstitution(response.data.data);

        setCIcurrentInstitutionName(response.data.data.name);
        setCIcurrentInstitutionStatus(response.data.data.status);
        setCIcurrentInstitutionEmail(response.data.data.email);
        setCIcurrentInstitutionOnBoardingYear(response.data.data.onBoardingYear);


      } else {
        // Handle the case where the request was not successful
        alert('Request failed:' + response.data.message);
      }
    } catch (error) {
      //alert(error);
      alert('Request error:'+ error);
      // Handle request error, e.g., display an error message to the user
    }
  };

  // Function to close the modal
  const closeAddModal = () => {
    setIsUpdateModalOpen(false);
    if (registrationStatus == "Updated Successfully") {
      navigate("/zaptrance-institutions");
    } else {
      
    }
    
  };

  // Function to validate email format
  const isValidEmail = (email) => {
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};



  const hitUpdateEndpoint  = async (value1, value2, value3, value4, value5, value6,) => { 


    // alert(
      
    //   parsedInstitution.id + "\n" + 
    //   cIcurrentInstitutionName + "\n" + 
    //   cIcurrentInstitutionStatus + "\n" + 
    //   cIcurrentInstitutionEmail + "\n" + 
    //   cIcurrentInstitutionOnBoardingYear
    // );

    // Validate email before proceeding
if (!isValidEmail(cIcurrentInstitutionEmail)) {
  //alert('Invalid email address');
  setRegistrationStatus("Invalid email address");
  setIsModalOpen(true);
  return;
}
    
    
     const formData = new FormData();
     formData.append('name', cIcurrentInstitutionName);
     formData.append('onBoardingyear', cIcurrentInstitutionOnBoardingYear);
     formData.append('contactEmail', cIcurrentInstitutionEmail);
    
    
    setIsUpdateLoading(true);
    try {
      // alert(`here: ${params.id}`);
      //console.log(value1, formData)
      const response = await axios.patch(`https://gacsstage.zaptrance.ng/api/admin/institutions/${parsedInstitution.id}`, formData, {
        headers: {
          'Content-Type': 'application/json', //'Content-Type': 'multipart/form-data', // Use multipart/form-data for file uploads
          Authorization: `Bearer ${token}`,
        },
      });

      setIsUpdateLoading(false);
      

      // Check if the request was successful
      if (response.data.success) {

        alert("Updated Successfully");
        setRegistrationStatus("Updated Successfully");
        
        
        //setIsDataLoading(false);

        setIsUpdateModalOpen(true);

        handleData();
      } else {
        

        alert('Request failed:' + 'No success');
        setErrorMessage("Update Failed");
        setIsUpdateModalOpen(true);

        //alert("notok1");
      }
    } catch (error) {
      setIsUpdateLoading(false);
      setRegistrationStatus("Update Failed");
            
      setIsRegistrationLoading(false);

      if (error.response && error.response.data && error.response.data.data) {
        const dataKeys = Object.keys(error.response.data.data);
    
        if (dataKeys.length > 0) {
          // Construct an error message from the data keys
          const errorMessage = dataKeys
            .map(key => {
              const messages = error.response.data.data[key];
              //alert(messages);
              //return `${key}: ${messages.join(', ')}`;
              //return `${messages.join(', ')}`;
              return `${messages}`;
            })
            .join('\n');
    
            setErrorMessage(errorMessage);
        } else {
          // If there are no data keys, set a generic error message
          setErrorMessage('An error occurred during update.');
        }
      } else {
        // Handle other error cases if needed
        setErrorMessage('An error occurred during update.');
      }
      setIsUpdateModalOpen(true);
    }

    
  };



  // UPdate
  const [logo, setLogo] = useState(null);

  const handleDropdownStatusChange = (event) => {
    const selectedValue = event.target.value;
    setCIcurrentInstitutionStatus(selectedValue);
  //
  //alert(selectedValue);
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
  // if (file) {
  //   setLogo(file);
  //   //alert('File selected: ' + file.name);
  //   //alert(file.name);
  // } else {
  //   alert('No file selected');
  // }
  if (file) {
    const reader = new FileReader();

    reader.onload = (readerEvent) => {
      setLogo(readerEvent.target.result);
    };

    reader.readAsDataURL(file);
  }
  };
    // UPdate
  

  return (
    <div className="content flex-grow">
        <div className="inner-content">
          <HeaderZaptrance />
          <div className="p-4" style={{ backgroundColor: '#F6F7FB' }}>
            <div className='text-black p-4 flex text-xl'>
              <div><BusinessIcon className='mr-4'/>Institution: {currentInstitution.name}</div>
            </div>

            <div className='flex text-right'>
              <div className="text-right">
                <button className="px-6 py-3 m-4" 
                style={{ width: '200px', 
                backgroundColor: '#095918', borderRadius: '8px',
                padding: '10px 20px', color: 'white', border: 'none', }}
                onClick={openAddProgramModal}
                >
                  Add Program
                </button>
              </div>
              
              <div className="text-right">
                <button className="px-6 py-3 m-4" 
                style={{ width: '200px', 
                backgroundColor: '#095918', borderRadius: '8px', 
                padding: '10px 20px', color: 'white', border: 'none', }}
                onClick={openAddPaymentModal}
                >
                  Add Payment
                </button>
              </div>
              
              <div className="text-right">
                <button className="px-6 py-3 m-4" 
                style={{ width: '200px', 
                backgroundColor: '#095918', borderRadius: '8px',
                padding: '10px 20px', color: 'white', border: 'none', }}
                onClick={openAddUserModal}
                >
                  Add User
                </button>
              </div>

              <div className="flex flex-col py-2 ">
                {additionalVariable == 'noEdit' ? <label></label> : '' }
                
                <img className="w-64 h-36 object-scale-down pb-4 " src={ additionalVariable == 'noEdit' ? "https://gacsstage.zaptrance.ng/" + currentInstitution.picture : logo } alt="" /> 
              
              {additionalVariable == 'noEdit' ? <div></div> :
                  <div className="flex flex-col py-2 px-4">            
                  <input
                    style={{ backgroundColor: '#EDF2F6', width: '100%' }}
                    type="file"
                    id="logoInput"
                    accept=".jpg, .jpeg"
                    onChange={handleLogoChange}
                  />
                </div>
                }
              </div>
            </div>
            
            <div>

                <div className="flex justify-between items-center w-full px-2 pt-4">
  <div className="flex items-center">
    <FontAwesomeIcon icon={faBuilding} color="black" className='mr-6' size="2x"/>
    <h2 className='text-xl'>Institution Details</h2>
  </div>


  <div>
    <button
      onClick={()=> {
        navigate("/zaptrance-institutions");
      }}
      className="border p-2"
      style={{
        background: 'none',
        cursor: 'pointer',
        borderRadius: '50%',
        borderColor: 'black',
        display: 'inline-block',
        width: '30px',
        height: '30px',
        padding: '0',
      }}
    >
      <span aria-hidden="true">
        <FontAwesomeIcon icon={faTimes} color="black" />
      </span>
    </button>
  </div>


</div>


<div className="w-full px-8 pt-4">

      

<div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">


<div className="flex flex-col py-2">
    <label>Institution Name</label>
    <input
      style={{ backgroundColor: '#EDF2F6', width: '100%' }}
      className="rounded-lg mt-2 p-2 focus"
      type="text"
      placeholder={cIcurrentInstitutionName}
      //value={additionalVariable}
      readOnly={additionalVariable === 'noEdit'}
      onChange={(e) => setCIcurrentInstitutionName(e.target.value)}
    />
  </div>

  <div className="flex flex-col py-2">
    <label>Institution Status</label>
    {additionalVariable == 'noEdit' ? 
    <input
      style={{ backgroundColor: '#EDF2F6', width: '100%' }}
      className="rounded-lg mt-2 p-2 focus"
      type="text"
      //placeholder="Please enter prgram name"
      value={cIcurrentInstitutionStatus}
      readOnly={true}
      onChange={(e) => setCIcurrentInstitutionStatus(e.target.value)}
    /> : 
    <select
              className="mt-2 p-2 focus border-nbteGreen border-2 rounded-xl"
              value={cIcurrentInstitutionStatus}
              onChange={(e) => handleDropdownStatusChange(e)}>
                <option value="Select">Select</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
            </select>
    }
  </div>
</div>


<div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">
<div className="flex flex-col py-2">
  <label>Email:</label>
  <input
      style={{ backgroundColor: '#EDF2F6', width: '100%' }}
      className="rounded-lg mt-2 p-2 focus"
      type="text"
      placeholder={cIcurrentInstitutionEmail}
      //value={currentInstitution.email}
      readOnly={additionalVariable === 'noEdit'}
      onChange={(e) => setCIcurrentInstitutionEmail(e.target.value)}
    />
</div>

{/* <div className="flex flex-col py-2">
    <label>OnBoardingYear</label>
    <input
      style={{ backgroundColor: '#EDF2F6', width: '100%' }}
      className="rounded-lg mt-2 p-2 focus"
      type="text"
      placeholder={cIcurrentInstitutionOnBoardingYear}
      //value={currentInstitution.onBoarding}
      readOnly={additionalVariable === 'noEdit'}
      onChange={(e) => setCIcurrentInstitutionOnBoardingYear(e.target.value)}
    />
  </div> */}

<div className="flex flex-col py-2">
            <label>OnBoardingYear</label>
            <select
                style={{ backgroundColor: '#EDF2F6', width: '100%' }}
                className="rounded-lg mt-2 p-2 focus"
                value={cIcurrentInstitutionOnBoardingYear}
                readOnly={additionalVariable === 'noEdit'}
                onChange={(e) => setCIcurrentInstitutionOnBoardingYear(e.target.value)}>
                  <option value="">Select Year</option>
                {years.map(year => (
                    <option key={year} value={year}>{year}</option>
                ))}
            </select>
        </div>



  
</div>




<div className="content flex-grow">
        <div className="inner-content">
          <div className="p-4" style={{ backgroundColor: '#F6F7FB' }}>


          <div className="text-l font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
            <ul className="flex flex-wrap -mb-px">
              <li className="mr-2">
                <a
                  href="#"
                  className={`inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 ${activeTab === 'users' ? 'text-green-800 border-blue-600' : ''}`}
                  onClick={() => handleTabClick('users')}
                >
                  Users
                </a>
              </li>
              <li className="mr-2">
                <a
                  href="#"
                  className={`inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 ${activeTab === 'payments' ? 'text-green-800 border-blue-600' : ''}`}
                  onClick={() => handleTabClick('payments')}
                >
                  Payments
                </a>
              </li>
              <li className="mr-2">
                <a
                  href="#"
                  className={`inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 ${activeTab === 'programs' ? 'text-green-800 border-blue-600' : ''}`}
                  onClick={() => handleTabClick('programs')}
                >
                  Programs
                </a>
              </li>
              
              
            </ul>
          </div>
          
          
          <div className="p-4">
            {activeTab === 'users' && <div> <ComponentUsers currentInstitution={loading ? [] : currentInstitution} /> </div>}
            {activeTab === 'payments' && <div> <ComponentPayments currentInstitution={loading ? [] : currentInstitution} /> </div>}
            {activeTab === 'programs' && <div> <ComponentPrograms currentInstitution={loading ? [] : currentInstitution} /> </div>}
          </div>



          </div>
        </div>
</div>







  <div className="text-center pt-2">
      

        {additionalVariable == 'noEdit' ? <div></div> : <button className="px-6 py-3 m-4" 
      style={{
      width: '200px',
      backgroundColor: '#095918',
      borderRadius: '30px',
      padding: '10px 20px',
      color: 'white',
      border: 'none',
    }}
    onClick={() => {
      if (!isUpdateLoading) {
        hitUpdateEndpoint();
      }
    }}
      >
        
              {isUpdateLoading ? <LoadingScreen /> : 'Update'}
        </button>}

        <button className="px-6 py-3 m-4" 
      style={{
      width: '200px',
      backgroundColor: '#095918',
      borderRadius: '30px',
      padding: '10px 20px',
      color: 'white',
      border: 'none',
    }}
    onClick={() => {
      //onRequestClose();
      clearFields();
      setRegistrationErrorMessage('');
      //alert(institution.id);
      navigate("/zaptrance-institutions");
    }}
      >
        
              Okay
        </button>



        
      </div>


</div>
              

              </div>
            
            
            
            <AddProgramToInstitutionModal
              isOpen={isAddProgramModalOpen}
              onRequestClose={closeAddProgramModal}
              institution={currentInstitution}
              //programTypes={programTypes}
              
            />
            <AddPaymentToInstitutionModal
              isOpen={isAddPaymentModalOpen}
              onRequestClose={closeAddPaymentModal}
              institution={currentInstitution}
              //programTypes={programTypes}
              
            />
            <AddUserToInstitutionModal
              isOpen={isAddUserModalOpen}
              onRequestClose={closeAddUserModal}
              institution={currentInstitution}
              //programTypes={programTypes}
              
            />

<UpdateModal
              isOpen={isUpdateModalOpen}
              onRequestClose={closeAddModal}
              registrationStatus={registrationStatus}
              registrationError={errorMessage}
            />

          </div>
        </div>
      </div>
  );
};

export default ZaptranceInstitutionDetail;
